import {
  BaseFieldWidget,
  BaseTableFieldWidget,
  ModelFieldType,
  RowContext,
  SPI,
  ViewType,
  Widget
} from '@kunlun/dependencies';
import { VNode } from 'vue';
import { formatStarRuleSummary } from './constants';

/**
 * 评估规则配置列表 - 「星级规则」摘要列
 *
 * <p>读取行内 starRules（OneToMany），渲染为摘要文本，如：
 * 「五星[90,120) 三星[70,90) 二星[50,70) 一星&lt;50」。</p>
 *
 * <p>绑定字段：DeliAriesPlatformEvaluationRule.starRules。
 * 复用默认 O2M 表格列 widget 名 'Table' + 字段名精确覆盖（不约束 model，避免代理/继承导致不匹配）。</p>
 */
@SPI.ClassFactory(
  BaseFieldWidget.Token({
    viewType: ViewType.Table,
    ttype: ModelFieldType.OneToMany,
    widget: 'Table',
    name: 'starRules'
  })
)
export class TableStarRuleSummaryFieldWidget extends BaseTableFieldWidget {
  @Widget.Method()
  public renderDefaultSlot(context: RowContext): VNode[] | string {
    const value = this.compute(context) as any[];
    return formatStarRuleSummary(value) || '-';
  }
}
